import * as moment from 'moment-timezone';

export function validatePickupTime(date) {
    const now = moment().tz('Europe/Zurich');

    return now.diff(date, 'minutes') <= 10;
}
